export const formatCPF = (cpf: string) => `${cpf.slice(0, 3)}.${cpf.slice(3, 6)}.${cpf.slice(6, 9)}-${cpf.slice(9)}`;

export const formatCNH = (cnh: string) => `${cnh.slice(0, 3)}.${cnh.slice(3, 6)}.${cnh.slice(6, 9)}.${cnh.slice(9)}`;
